import { render } from "./MedInter.vue?vue&type=template&id=380df402&scoped=true"
import script from "./MedInter.vue?vue&type=script&lang=js"
export * from "./MedInter.vue?vue&type=script&lang=js"

import "./MedInter.vue?vue&type=style&index=0&id=380df402&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380df402"]])

export default __exports__